<template>
  <div>
    <v-row no-gutters>
      <v-col class="pa-5" :class="dShowAddCompType == true ? 'pr-3 borderRightAlt col-12 col-md-7' : 'col-12'">
        <v-row no-gutters align="center">
          <v-col>
            <p class="fcT240 fs14 mb-0">{{ $t("datGeneric.total") }} ({{ dTotalItems }})</p>
          </v-col>
          <v-col cols="4" class="searchInput px-2">
            <v-text-field
              v-model="dSearch"
              append-icon="mdi-magnify"
              :label="$t('labels.search')"
              color="datPrimary"
              class="mt-0 py-0"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="auto" class="px-2">
            <v-btn depressed class="datPrimaryBtnOut" @click="fNewType">{{$t("btn.new")}}</v-btn>
          </v-col>
          <v-col cols="12" class="mt-4">
            <v-data-table
              :headers="dTableHeaders"
              :items="dComplaintTypes"
              :options.sync="dPagination"
              :server-items-length="dTotalItems"
              :item-key="dItemKey"
              :loading="dLoading"
              :noDataText="$t('datGeneric.noData')"
              :loading-text="$t('labels.loadingItems')"
              class="datTable"
              :footer-props="{
                'items-per-page-options': [5, 10, 20],
                'items-per-page-text': $t('labels.elementsPerPage'),
                pageText: '{0}-{1} de {2}'}"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn icon @click="fEditType(item)">
                  <v-icon color="datPrimary">mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon class="datDeleteBtnIcon ml-1" @click="fDeleteAlert(item)">
                  <v-icon color="datDeleteBtnIcon">mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-col>

      <!-- Formulario nuevo tipo de denuncia -->
      <v-col cols="5" v-if="dShowAddCompType" class="stickyForm">
        <v-col cols="12" class="px-5">
          <v-row>
            <v-col cols="12">
              <p class="fs16 fcC2 font-weight-bold"> {{ $t("datFormsTitles.newCompType") }} </p>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-text-field
                v-model.number="dSelectedType.typeId"
                :id="'dSelectedType.typeId'"
                :disabled="true"
                :label="$t('datGeneric.id')"
                item-color="datPrimary"
                color="datPrimary"
                class="ma-0 pa-0"
              />
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-text-field
                v-model.number="dSelectedType.typeDescription"
                :id="'dSelectedType.typeDescription'"
                :label="$t('datGeneric.description')+'*'"
                item-color="datPrimary"
                color="datPrimary"
                class="ma-0 pa-0"
              />
            </v-col>
            <v-col cols="6" class="pt-0">
              <v-text-field
                v-model.number="dSelectedType.daysAccept"
                :id="'dSelectedType.daysAccept'"
                :label="$t('datGeneric.daysAccept')+'*'"
                type="number"  
                item-color="datPrimary"
                color="datPrimary"
                class="ma-0 pa-0"
              />
            </v-col>
            <v-col cols="6" class="pt-0">
              <v-text-field
                v-model.number="dSelectedType.daysExp"
                :id="'dSelectedType.daysExp'"
                :label="$t('datGeneric.maxDaysExp')+'*'"
                type="number"  
                item-color="datPrimary"
                color="datPrimary"
                class="ma-0 pa-0"
              />
            </v-col>
            <v-col cols="6" class="pt-0">
              <v-text-field
                v-model.number="dSelectedType.daysResol"
                :id="'dSelectedType.daysResol'"
                :label="$t('datGeneric.maxDaysResolution')"
                type="number"  
                item-color="datPrimary"
                color="datPrimary"
                class="ma-0 pa-0"
              />
            </v-col>
            <v-col cols="6" class="pt-0">
              <v-text-field
                v-model.number="dSelectedType.daysReopen"
                :id="'dSelectedType.daysReopen'"
                :label="$t('datGeneric.maxDaysReopen')+'*'"
                type="number"  
                item-color="datPrimary"
                color="datPrimary"
                class="ma-0 pa-0"
              />
            </v-col>
            <v-col cols="6" class="pt-0">
              <v-switch inset v-model="dSelectedType.preliminarPhase" 
                        color="datPrimary" 
                        true-value="S" 
                        false-value="N"
                        hide-details  
                        :label="$t('datTableHeader.preliminarPhase')"
                        class="ma-0 pa-0">
              </v-switch> 
            </v-col>
            <v-col v-if="dSelectedType.preliminarPhase == 'S'" cols="6" class="pt-0">
              <v-text-field
                v-model.number="dSelectedType.daysFp"
                :id="'dSelectedType.daysFp'"
                :label="$t('datGeneric.maxDaysPreliminar')+'*'"
                type="number"  
                item-color="datPrimary"
                color="datPrimary"
                class="ma-0 pa-0"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col class="px-3">
          <v-row no-gutters justify="end">
            <v-col cols="auto" class="px-2">
              <v-btn depressed class="datPrimaryBtnOut" @click="fCloseEdit(false)">{{$t("datBtn.close")}}</v-btn>
            </v-col>
            <v-col cols="auto" class="px-2">
              <v-btn depressed class="datPrimaryBtn" @click="fSave">{{$t("datBtn.save")}}</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-col>
    </v-row>
  </div>
</template>
  
<script>
  import ServiceEcomplaints from "@/services/srv-eComplaints"
  import mxCanalDenuncias from '@/mixins/mxCanalDenuncias.vue'

  export default {
    mixins: [mxCanalDenuncias],
    
    props: {
      pShowSnackbar:{
        type: String,
        default: 'BOTH' // SON PARENT BOTH
      }
    },
    data() {
      return {
        dSearch: '',
        dTableHeaders: [
          {
            text: this.$t("datGeneric.id"),
            value: "typeId",
            align: "left",
            sortable: false,
          },
          {
            text: this.$t("datGeneric.description"),
            value: "typeDescription",
            align: "left",
            sortable: false,
          },
          {
            text: this.$t("datTableHeader.preliminarPhase"),
            value: "preliminarPhase",
            align: "left",
            sortable: false,
          },
          {
            text: this.$t("datTableHeader.actions"),
            value: "actions",
            align: "right",
            sortable: false,
          },
        ],
        dTotalItems: 0,
        dPagination: {},
        dComplaintTypes: [],
        dLoading: false,
        dSearchTime: 0,
        dItemKey: "typeId",
        dSelectedType: {},
        dShowAddCompType: false,
      }
    },

    mounted() {
      this.fGetCompTypesList()
    },

    methods: {
      // Elimina el tipo de denuncia 
      fRemoveCompType() {
        const payload = {
          typeId: this.dSelectedType.typeId,
        }

        ServiceEcomplaints.delComplaintType(payload).then((response) => {
          if (response.statusCode === '200' && response.infoMsg.code === 0) {
            this.fSnackBarSuccess(this.$t("datAlert.deleteType"))
            this.fGetCompTypesList()
          }
        }).catch((error) => {
          this.fSnackbarError(error, this.pShowSnackbar)
        })
      },

      // Introduce un nuevo tipo de denuncia 
      fSetCompType() {
        const payload = {
          typeDescription: this.dSelectedType.typeDescription,
          preliminarPhase: this.dSelectedType.preliminarPhase ? this.dSelectedType.preliminarPhase : 'N',
          daysAccept: this.dSelectedType.daysAccept,
          daysFp: this.dSelectedType.daysFp,
          daysExp: this.dSelectedType.daysExp,
          daysResol: this.dSelectedType.daysResol,
          daysReopen: this.dSelectedType.daysReopen
        }
        ServiceEcomplaints.setComplaintType(payload).then((response) => {
          if (response.statusCode === '200' && response.infoMsg.code === 0) {
            this.fSnackBarSuccess(this.$t("datAlert.saveComplaintType"))
            this.fCloseEdit(true)
          } 
        }).catch((error) => {
          this.fSnackbarError(error, this.pShowSnackbar)
        })
      },

      // Actualiza un tipo de denuncia 
      fUpdateCompType() {
        const payload = {
          typeId: this.dSelectedType.typeId,
          typeDescription: this.dSelectedType.typeDescription,
          preliminarPhase: this.dSelectedType.preliminarPhase,
          daysAccept: this.dSelectedType.daysAccept,
          daysFp: this.dSelectedType.daysFp,
          daysExp: this.dSelectedType.daysExp,
          daysResol: this.dSelectedType.daysResol,
          daysReopen: this.dSelectedType.daysReopen
        }
        ServiceEcomplaints.updateComplaintType(payload).then((response) => {
          if (response.statusCode === '200' && response.infoMsg.code === 0) {
            this.fSnackBarSuccess(this.$t("datAlert.updateComplaintType"))
            this.fCloseEdit(true)
          } 
        }).catch((error) => {
          this.fSnackbarError(error, this.pShowSnackbar)
        })
      },

      // Obtiene la lista con todos los tipos de denuncias
      fGetCompTypesList() {
        this.dLoadingTable = true
        const payload = {
          search: this.dSearch,
          searchCols: "typeId, typeDescription, preliminarPhase",
          numRows: this.dPagination.itemsPerPage,
          offset: (this.dPagination.page - 1) * this.dPagination.itemsPerPage + 1,
          orderBy: this.dPagination.sortBy[0],
          order: this.dPagination.sortDesc[0] ? "DESC" : "ASC",
        }
        ServiceEcomplaints.getComplaintTypes(payload)
          .then((response) => {
            this.dComplaintTypes = global.structuredClone(response.dataRes)
            this.dTotalItems = response.numReg
          }).catch((error) => {
            this.fSnackbarError(error, this.pShowSnackbar)
          }).finally(() => {
            this.dLoadingTable = false
          })
      },

      // Abre la modal de edición de directorios para un directorio nuevo
      fNewType() {
        this.dShowAddCompType = true
        this.dSelectedType = {}
      },

      // Abre la modal de edición de directorios para cambiar el nombre de un directorio
      fEditType(item) {
        this.dSelectedType = item
        this.dShowAddCompType = true
      },

      // Cierra el formulario de modificación de directorios
      fCloseEdit(reload) {
        this.dShowAddCompType = false
        this.dSelectedType = {}
        if(reload){
          this.fGetCompTypesList()
        }
      },

      // Guarda o actualiza los nuevos tipos de denuncias
      fSave() {
        let error = this.fCheckValues()
        if(error){
          this.fSnackbarError(error, this.pShowSnackbar)
        } else if(this.dSelectedType.typeId){
          this.fUpdateCompType()
        }else{
          this.fSetCompType()
        }
      },

      // Alerta de borrado de tipo de denuncia
      fDeleteAlert(compType){
        this.dSelectedType = compType

        const alert = {
          text: this.$t('datAlert.deleteComplaint'),
          action: this.fRemoveCompType,
          icon: 'mdi-information-outline',
          btnText: this.$t('datBtn.accept'),
          btnTextCancel: this.$t('datBtn.cancel'),
          type: 'warning'
        }

        this.$bus.$emit('showAlert', alert)
      },

      fSearch() {
        clearInterval(this.dSearchTime)
        this.dSearchTime = setTimeout(
          function () {
            this.dPagination.page = 1
            this.fGetCompTypesList()
          }.bind(this),
          500
        )
      },

      // Comprueba que los campos obligatorios se han rellenado
      fCheckValues(){
        let error 
        if(this.fCheckSingleValue(this.dSelectedType.typeDescription)){
          error = this.$t('datError.noDescription')
        }else if(this.fCheckSingleValue(this.dSelectedType.daysAccept)){
          error = this.$t('datError.noDaysAccept')
        }else if(this.fCheckSingleValue(this.dSelectedType.daysFp)){
          error = this.$t('datError.noDaysFp')
        }else if(this.fCheckSingleValue(this.dSelectedType.daysExp)){
          error = this.$t('datError.noDaysExp')          
        }else if(this.fCheckSingleValue(this.dSelectedType.daysReopen)){
          error = this.$t('datError.noDaysReopen')
        } 

        return error                   
      }
    },
    watch: {
      dSearch() {
        this.fSearch()
      },
      dPagination: {
        deep: true,
        handler() {
          this.fGetCompTypesList()
        },
      },
    },
  }
</script>